// Datos centralizados de Polarizados Querétaro (PPQ)
export const WHATSAPP_NUMBER = "+52 1 442 342 9535";
export const WA_BASE = "https://wa.me/5214423429535";

export const waLink = (msg = "Hola, me gustaría realizar una cotización") =>
  `${WA_BASE}?text=${encodeURIComponent(msg)}`;

export const HERO_BG =
  "https://images.unsplash.com/photo-1775466145653-a47a853428d2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBtb2Rlcm4lMjBob21lJTIwZXh0ZXJpb3IlMjBsYXJnZSUyMHdpbmRvd3N8ZW58MHx8fHwxNzc4NDQ0MTI4fDA&ixlib=rb-4.1.0&q=85";

export const OFFICE_BG =
  "https://images.unsplash.com/photo-1778050368592-ec4b8ab3546d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBvZmZpY2UlMjBidWlsZGluZyUyMGdsYXNzJTIwZmFjYWRlfGVufDB8fHx8MTc3ODQ0NDEyOHww&ixlib=rb-4.1.0&q=85";

export const ABSTRACT_BG =
  "https://images.unsplash.com/photo-1761078739436-ccee01f3d89c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwxfHxhYnN0cmFjdCUyMGRhcmslMjBnbGFzcyUyMGJhY2tncm91bmR8ZW58MHx8fHwxNzc4NDQ0MTUwfDA&ixlib=rb-4.1.0&q=85";

export const WORKER_BG =
  "https://customer-assets.emergentagent.com/job_ventanas-polarizadas/artifacts/hffn2uhn_instalacion%20profesional.jpeg";

// Imágenes adicionales (Unsplash – sin tracking IDs largos para variedad)
export const IMG_RAYBAN =
  "https://customer-assets.emergentagent.com/job_ventanas-polarizadas/artifacts/gxn9uek4_rayban.jpeg";
export const IMG_PLATA =
  "https://customer-assets.emergentagent.com/job_ventanas-polarizadas/artifacts/xz0odimb_plata.jpeg";
export const IMG_HUMO =
  "https://customer-assets.emergentagent.com/job_ventanas-polarizadas/artifacts/u13abjc4_humo.jpeg";
export const IMG_ESMERILADO =
  "https://customer-assets.emergentagent.com/job_ventanas-polarizadas/artifacts/8bar7kei_esmerilado%20liso.jpeg";
// Proyectos reales — fotos del cliente
export const IMG_PROJ_RESIDENCIAL_DOBLE =
  "https://customer-assets.emergentagent.com/job_ventanas-polarizadas/artifacts/tj8kmtpa_descarga.png";
export const IMG_PROJ_SALA_DECORATIVA =
  "https://customer-assets.emergentagent.com/job_ventanas-polarizadas/artifacts/24rjm1dd_descarga%20%281%29.png";
export const IMG_PROJ_INSTALACION_ALTURA =
  "https://customer-assets.emergentagent.com/job_ventanas-polarizadas/artifacts/v9yg41bd_descarga%20%282%29.png";
export const IMG_PROJ_FACHADA_CRISTAL =
  "https://customer-assets.emergentagent.com/job_ventanas-polarizadas/artifacts/ywehhfef_descarga%20%283%29.png";
export const IMG_PROJ_PENTHOUSE =
  "https://customer-assets.emergentagent.com/job_ventanas-polarizadas/artifacts/yspjnosu_descarga%20%284%29.png";
export const IMG_PROJ_RAYBAN_DETALLE =
  "https://customer-assets.emergentagent.com/job_ventanas-polarizadas/artifacts/xr5kgrfn_descarga%20%285%29.png";
export const IMG_PROJ_RAYBAN_ALBERCA_PROCESO =
  "https://customer-assets.emergentagent.com/job_ventanas-polarizadas/artifacts/5kp0vz7z_descarga%20%286%29.png";
export const IMG_PROJ_INSTALACION_CIUDAD =
  "https://customer-assets.emergentagent.com/job_ventanas-polarizadas/artifacts/mgvu9qpx_descarga%20%287%29.png";
export const IMG_PROJ_AGENCIA_NOCTURNA =
  "https://customer-assets.emergentagent.com/job_ventanas-polarizadas/artifacts/3pa4reyk_descarga%20%288%29.png";
export const IMG_PROJ_RAYBAN_ALBERCA_RESULTADO =
  "https://customer-assets.emergentagent.com/job_ventanas-polarizadas/artifacts/tqm9ytly_descarga%20%289%29.png";
export const IMG_PROJ_AGENCIA_INTERIOR_DETALLE =
  "https://customer-assets.emergentagent.com/job_ventanas-polarizadas/artifacts/41k0d6sp_descarga%20%2810%29.png";
export const IMG_PROJ_AGENCIA_NOCHE_LED =
  "https://customer-assets.emergentagent.com/job_ventanas-polarizadas/artifacts/a38mmtju_descarga%20%2811%29.png";
export const IMG_PROJ_AGENCIA_RESULTADO_DIA =
  "https://customer-assets.emergentagent.com/job_ventanas-polarizadas/artifacts/57yln58a_descarga%20%2812%29.png";
export const IMG_PROJ_AGENCIA_FACHADA_DIA =
  "https://customer-assets.emergentagent.com/job_ventanas-polarizadas/artifacts/6gm3jb5l_descarga%20%2813%29.png";
export const IMG_PROJ_AGENCIA_ANDAMIO_INTERIOR =
  "https://customer-assets.emergentagent.com/job_ventanas-polarizadas/artifacts/safarqh7_descarga%20%2814%29.png";

export const IMG_INTERIOR_VIEW =
  "https://customer-assets.emergentagent.com/job_ventanas-polarizadas/artifacts/iuumc8me_ventana%20vista.jpeg";
export const IMG_INDUSTRIAL =
  "https://images.unsplash.com/photo-1565939695748-9b4f5ad21c2c?auto=format&fit=crop&w=1600&q=80";
export const IMG_RESIDENTIAL =
  "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1600&q=80";
export const IMG_COMMERCIAL =
  "https://images.unsplash.com/photo-1556761175-5973dc0f32e7?auto=format&fit=crop&w=1600&q=80";
export const IMG_SECURITY =
  "https://customer-assets.emergentagent.com/job_ventanas-polarizadas/artifacts/wgcuow2x_Seguridad%20transparente.jpeg";
export const IMG_SOLAR =
  "https://images.unsplash.com/photo-1518770660439-4636190af475?auto=format&fit=crop&w=1600&q=80";
export const IMG_FACADE =
  "https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=1600&q=80";
export const IMG_PENTHOUSE =
  "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&w=1600&q=80";
export const IMG_FROSTED =
  "https://images.unsplash.com/photo-1582719188393-bb71ca45dbb9?auto=format&fit=crop&w=1600&q=80";
export const IMG_MIRROR =
  "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?auto=format&fit=crop&w=1600&q=80";

// Espacios / tipo de proyecto (dónde se aplica)
export const SERVICES = [
  {
    id: "industrial",
    icon: "Factory",
    title: "Industrial",
    subtitle: "Plantas, naves y bodegas",
    description:
      "Película de polarizado para plantas industriales, naves, fábricas y bodegas en Querétaro. Cumple normativas de Protección Civil.",
    tags: ["Seguridad", "Control solar", "Por m²"],
    image: IMG_INDUSTRIAL,
    waMsg: "Hola, quiero información sobre polarizado industrial",
  },
  {
    id: "oficinas",
    icon: "Building2",
    title: "Edificios y Oficinas",
    subtitle: "Fachadas y corporativos",
    description:
      "Polarizado arquitectónico para fachadas, ventanales corporativos y salas de juntas. Privacidad, ahorro energético y estética profesional.",
    tags: ["Arquitectónico", "Privacidad", "Ahorro"],
    image: OFFICE_BG,
    waMsg: "Hola, quiero información sobre polarizado para edificios u oficinas",
  },
  {
    id: "residencial",
    icon: "Home",
    title: "Residencial",
    subtitle: "Casas y departamentos",
    description:
      "Película para ventanas de casa y departamento. Reduce el calor, protege muebles de rayos UV y añade privacidad sin perder luz natural.",
    tags: ["Anti-UV", "Privacidad", "Confort"],
    image: HERO_BG,
    waMsg: "Hola, quiero información sobre polarizado residencial",
  },
  {
    id: "comercios",
    icon: "Store",
    title: "Comercios y Locales",
    subtitle: "Restaurantes y aparadores",
    description:
      "Polarizado para locales comerciales, restaurantes y aparadores. Film decorativo, esmerilado o reflectivo para transformar tu espacio.",
    tags: ["Decorativo", "Esmerilado", "Reflectivo"],
    image: IMG_COMMERCIAL,
    waMsg: "Hola, quiero información sobre polarizado para comercios",
  },
];

export const FILM_TYPES = [
  {
    id: "seguridad-transparente",
    name: "Seguridad transparente",
    tagline: "Antiasalto · invisible al ojo",
    description:
      "Película de seguridad totalmente transparente que refuerza el vidrio ante impactos, intentos de robo y rotura accidental. No altera la estética: tu cristal se ve igual, pero queda blindado por dentro. Cumple normativas de Protección Civil.",
    features: [
      "100% transparente — no oscurece el cristal",
      "Disponible en 4, 6 y 8 micras",
      "Cumple Protección Civil",
      "Retiene fragmentos en caso de rotura",
    ],
    image: IMG_SECURITY,
  },
  {
    id: "rayban",
    name: "Ray-Ban",
    tagline: "Acabado oscuro · privacidad total exterior",
    description:
      "Película Ray-Ban con acabado oscuro tipo lente de sol. Privacidad total desde el exterior durante el día y máximo control solar. Perfecta para residencias con vistas, penthouses, ventanales en alberca y áreas donde el sol pega directo.",
    features: [
      "Privacidad diurna total desde el exterior",
      "Máximo bloqueo de calor",
      "Acabado oscuro elegante",
      "Ideal para residencial premium",
    ],
    image: IMG_RAYBAN,
  },
  {
    id: "esmerilado-liso",
    name: "Esmerilado liso",
    tagline: "Privacidad · pasa la luz",
    description:
      "Acabado mate uniforme tipo vidrio esmerilado. Bloquea la visibilidad pero deja pasar la luz natural — ideal para baños, divisiones de oficina, salas de juntas, cancelería interior y aparadores comerciales que requieren intimidad sin sacrificar luminosidad.",
    features: [
      "Acabado mate uniforme",
      "Privacidad sin bloquear luz",
      "Ideal para baños y oficinas",
      "Aplicación rápida y limpia",
    ],
    image: IMG_ESMERILADO,
  },
  {
    id: "reflecta-plata",
    name: "Reflecta plata",
    tagline: "Efecto espejo · privacidad diurna",
    description:
      "Película reflectiva color plata con efecto espejo desde el exterior. Privacidad total de día, control solar elevado y estética arquitectónica de gran impacto. Perfecta para fachadas de edificios, ventanales corporativos y locales comerciales.",
    features: [
      "Efecto espejo de día",
      "Alto rechazo de calor",
      "Ideal para fachadas corporativas",
      "Acabado plata uniforme",
    ],
    image: IMG_PLATA,
  },
  {
    id: "plata-humo",
    name: "Plata humo",
    tagline: "Reflectivo ahumado · elegante",
    description:
      "Variante en tono humo del reflectivo plata. Combina la privacidad diurna y el control solar del espejo con un acabado más oscuro y elegante — perfecta para fachadas comerciales, agencias y proyectos arquitectónicos que buscan presencia visual sin reflejar tanta luz.",
    features: [
      "Acabado humo elegante",
      "Privacidad diurna",
      "Reduce deslumbramiento",
      "Ideal para agencias y comercios premium",
    ],
    image: IMG_HUMO,
  },
];

export const STATS = [
  { value: "99", suffix: "%", label: "Bloqueo de rayos UV dañinos" },
  { value: "80", suffix: "%", label: "Reducción de calor solar" },
  { value: "30", suffix: "%", label: "Ahorro promedio en electricidad" },
  { value: "5", suffix: "+", label: "Años de experiencia" },
];

export const PROJECTS = [
  {
    id: 1,
    title: "Polarizado residencial",
    category: "Residencial",
    image: IMG_PROJ_RESIDENCIAL_DOBLE,
    desc: "Ventanales de doble altura — control solar y privacidad.",
  },
  {
    id: 2,
    title: "Resultado final",
    category: "Residencial",
    image: IMG_PROJ_SALA_DECORATIVA,
    desc: "Sala-comedor — película decorativa de color en claraboyas.",
  },
  {
    id: 3,
    title: "Fachada de cristal",
    category: "Edificios",
    image: IMG_PROJ_FACHADA_CRISTAL,
    desc: "Polarizado arquitectónico en ventanales de doble nivel.",
  },
  {
    id: 4,
    title: "Película inteligente azul",
    category: "Residencial",
    image: IMG_PROJ_PENTHOUSE,
    desc: "Penthouse con vista panorámica — control solar + privacidad en fachada completa.",
  },
  {
    id: 5,
    title: "Nuestro equipo",
    category: "Instalación",
    image: IMG_PROJ_INSTALACION_ALTURA,
    desc: "Instalación en altura — técnicos certificados, trabajo limpio y seguro.",
  },
  {
    id: 6,
    title: "Película Ray-Ban — Detalle de ventana",
    category: "Residencial",
    image: IMG_PROJ_RAYBAN_DETALLE,
    desc: "Acabado espejo oscuro — máxima privacidad y control solar.",
  },
  {
    id: 7,
    title: "En proceso — Residencia con alberca",
    category: "Residencial",
    image: IMG_PROJ_RAYBAN_ALBERCA_PROCESO,
    desc: "Instalación de película Ray-Ban — ventanal vista a jardín y alberca.",
  },
  {
    id: 8,
    title: "Resultado — Ventanal residencial",
    category: "Residencial",
    image: IMG_PROJ_RAYBAN_ALBERCA_RESULTADO,
    desc: "Película Ray-Ban oscura — privacidad total desde el exterior en residencia con alberca.",
  },
  {
    id: 9,
    title: "Instalación en altura — Vista panorámica",
    category: "Comercial",
    image: IMG_PROJ_INSTALACION_CIUDAD,
    desc: "Gran formato — instalación en equipo sobre andamio con vista de la ciudad.",
  },
  {
    id: 10,
    title: "Instalación nocturna — Agencia automotriz",
    category: "Comercial",
    image: IMG_PROJ_AGENCIA_NOCTURNA,
    desc: "Película seguridad humo — fachada completa de vidrio, trabajo en andamio nocturno.",
  },
  {
    id: 11,
    title: "Película seguridad humo — Fachada exterior",
    category: "Comercial",
    image: IMG_PROJ_AGENCIA_FACHADA_DIA,
    desc: "Control solar + seguridad antiasalto en vidrio templado. Agencia automotriz — fachada completa.",
  },
  {
    id: 12,
    title: "Detalle de fachada — Película humo",
    category: "Comercial",
    image: IMG_PROJ_AGENCIA_INTERIOR_DETALLE,
    desc: "Privacidad diurna — el interior no se ve desde afuera. Agencia comercial.",
  },
  {
    id: 13,
    title: "Vista interior del proceso",
    category: "Comercial",
    image: IMG_PROJ_AGENCIA_ANDAMIO_INTERIOR,
    desc: "Andamio interior — instalación precisa en vidrio de gran formato.",
  },
  {
    id: 14,
    title: "Instalación nocturna — Agencia comercial",
    category: "Comercial",
    image: IMG_PROJ_AGENCIA_NOCHE_LED,
    desc: "Fachada completa de vidrio — trabajo en andamio nocturno.",
  },
  {
    id: 15,
    title: "Resultado final — Fachada completa terminada",
    category: "Comercial",
    image: IMG_PROJ_AGENCIA_RESULTADO_DIA,
    desc: "Acabado uniforme — película humo en toda la fachada comercial.",
  },
];

export const PROCESS_STEPS = [
  {
    n: "01",
    title: "Contáctanos por WhatsApp",
    desc: "Dinos qué tipo de espacio tienes — residencial, oficina, comercio o planta industrial.",
  },
  {
    n: "02",
    title: "Envíanos tus medidas",
    desc: "Compártenos las medidas aproximadas de tus ventanas por WhatsApp y te cotizamos de inmediato.",
  },
  {
    n: "03",
    title: "Cotización detallada",
    desc: "Recibes una cotización clara por m² con tipo de película, tiempo de instalación y garantía.",
  },
  {
    n: "04",
    title: "Instalación profesional",
    desc: "Nuestro equipo instala sin suciedad, sin burbujas. Garantía por escrito el mismo día.",
  },
];

export const BLOG_POSTS = [
  {
    tag: "Industrial",
    title: "Polarizado para plantas industriales en Querétaro: cumple Protección Civil",
    excerpt:
      "Cómo la película de seguridad ayuda a cumplir con la norma de Protección Civil en fábricas y plantas.",
    waMsg: "Hola, vi su artículo sobre polarizado industrial y quiero más información",
  },
  {
    tag: "Comercial",
    title: "Control solar en edificios: ahorra hasta 30% en electricidad",
    excerpt:
      "La película de control solar en ventanales corporativos reduce la carga del aire acondicionado.",
    waMsg: "Hola, vi su artículo sobre control solar en edificios",
  },
  {
    tag: "Oficinas",
    title: "¿Cuánto cuesta el polarizado para oficinas? Guía de precios 2025",
    excerpt:
      "Costos por m² según tipo de película (nanocerámica, espejo, seguridad) para proyectos corporativos.",
    waMsg: "Hola, quiero saber el precio del polarizado para oficinas",
  },
  {
    tag: "Guía",
    title: "Película de polarizado para casa: guía completa para elegir la correcta",
    excerpt:
      "Tipos de película, niveles de privacidad, precios y qué marcas usar antes de polarizar tu hogar.",
    waMsg: "Hola, quiero información sobre película de polarizado para mi casa",
  },
  {
    tag: "Comercios",
    title: "Polarizado para comercios: más clientes, menos calor",
    excerpt:
      "Cómo la película esmerilada y el polarizado decorativo transforman locales comerciales.",
    waMsg: "Hola, quiero información sobre polarizado para comercio",
  },
  {
    tag: "Tecnología",
    title: "Nanocerámica vs convencional: ¿cuál elegir?",
    excerpt:
      "Comparativa de rendimiento, precio y durabilidad entre las películas más solicitadas.",
    waMsg: "Hola, quiero información sobre película nanocerámica",
  },
];

export const BENEFITS = [
  "Cotización sin compromiso — envíanos medidas por WhatsApp y respondemos en menos de 1 hora",
  "Películas certificadas 3M, Solex y Llumar — las mejores marcas disponibles en México",
  "Garantía de instalación por escrito — sin burbujas, sin desprendimientos",
  "Cumplimos con reglamento de Protección Civil para proyectos industriales y comerciales",
  "Cobertura en toda la zona metropolitana: Centro, Corregidora, El Marqués, San Juan del Río",
];
